module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1yLwq"))).then(() => module.bundle.root('d0iPb'));